import apiClient from '../api';

// Create a new note
export const createNote = (data, header) => apiClient.post('/notes', data, header);

// Get all notes with pagination and filters
export const getAllNotes = (params = {}, header) => {
    const queryParams = new URLSearchParams();
    
    queryParams.append('organizationId', params.organizationId)
    // Add pagination params
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    
    // Add filter params
    if (params.search) queryParams.append('search', params.search);
    
    // Add sorting params
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/notes?${queryString}` : '/notes';
    
    return apiClient.get(url, header);
};

// Get a single note by ID
export const getNoteById = (id, header) => apiClient.get(`/notes/${id}`, header);

// Update a note
export const updateNote = (id, data, header) => apiClient.put(`/notes/${id}`, data, header);

// Delete a note
export const deleteNote = (id, header) => apiClient.delete(`/notes/${id}`, header);

// // Toggle star status
// export const toggleStarNote = (id, header) => apiClient.patch(`/notes/${id}/star`, header);

// // Toggle archive status
// export const toggleArchiveNote = (id, header) => apiClient.patch(`/notes/${id}/archive`, header);

// Get notes statistics
export const getNotesStats = ( header) => apiClient.get('/notes/stats', header);
